import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import BadgeStatus from "../../../common/BadgeStatus";
import ClaimsUpload from "../../../components/Claims/ClaimsUpload";
import Spinner from "../../../components/SpringLoader/index";
import AlertService from "../../../components/SweetAlert";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { GET, newFetch, PUT } from "../../../helpers/fetch";

const ClaimsUpdate = () => {
  const { t } = useTranslation();
  const [claimTypes, setClaimTypes] = useState([]);
  const [claims, setClaims] = useState([]);
  const [currentClaim, setCurrentClaim] = useState(null);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const initialClaim = location.state?.claim;

  const fetchAll = async () => {
    try {
      let api_path = `/claimtypes/0`;
      let api_pathClaims = `/associate/claims/${
        JSON.parse(localStorage.getItem("user")).id
      }/null`;
      let claimsResponse = await newFetch(GET, api_pathClaims);
      let response = await newFetch(GET, api_path);

      if (response.success && claimsResponse.success) {
        let claimTypes = response.data;
        setClaimTypes(claimTypes);
        let claims = claimsResponse.data;
        setClaims(claims);
        setLoading(false);
      } else {
        if (response.success) {
          ToastUtil.success(claimsResponse.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancel = async (claim) => {
    if (
      await AlertService.confirm(
        "",
        `${t("Are you sure you want to cancel the claim?")}`
      )
    ) {
      const editStatus = "Cancelled";
      const api_path = `/associate/claims/${claim.id}`;

      const response = await newFetch(PUT, api_path, {
        editStatus,
      });

      if (response.success) {
        ToastUtil.success(response.message);
        setCurrentClaim((prevClaim) => ({
          ...prevClaim,
          status: "Cancelled",
        }));

        updateState();
      } else {
        ToastUtil.error(response.message);
      }
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    fetchAll();
  }, [update]);

  useEffect(() => {
    if (initialClaim) {
      setCurrentClaim(initialClaim);
    }
  }, [initialClaim]);

  const displayClaim = currentClaim || initialClaim;

  if (!displayClaim) {
    return <div>{t("No claim data available")}</div>;
  }

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/claims">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Manage Claim")} #{displayClaim.id}
        </h4>
        <div className="d-flex justify-content-between my-3">
          <div>
            <div className="header-thick">{t("Status")}</div>
            <BadgeStatus status={displayClaim.status} />
          </div>
          {displayClaim.status.toLowerCase().includes("pending") && (
            <div className="d-flex align-items-center">
              <button
                className="btn btn-dark"
                onClick={() => {
                  handleCancel(displayClaim);
                }}
              >
                {t("Cancel Claim")}
              </button>
            </div>
          )}
        </div>

        <div className="accordion my-3 bg-white" id="accordionFAQs">
          {loading ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <ClaimsUpload
                claimTypes={claimTypes}
                updateState={updateState}
                claimData={displayClaim}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimsUpdate;
